import { useEffect } from 'react';

import { ALL_CLASSES } from 'src/constants/classes.constants';
import { useActiveUserClasses } from 'src/hooks/use-active-user-classes';
import { getLastSelectedTeacherClassId } from 'src/services/class-picker.service';
import { setSelectedClass } from 'src/store/features';
import { useAppDispatch } from 'src/store/redux';

export const useInitialSelectedClass = () => {
  const { activeUserClasses, isLoading } = useActiveUserClasses();

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!activeUserClasses || isLoading) return;

    if (!activeUserClasses.length) {
      dispatch(setSelectedClass(null));
      return;
    }

    const lastSelectedClassId = getLastSelectedTeacherClassId();

    if (lastSelectedClassId === ALL_CLASSES) {
      dispatch(setSelectedClass(activeUserClasses));
      return;
    }

    const actualLastSelectedClass = activeUserClasses.find(
      (cl) => cl.sourcedId === lastSelectedClassId,
    );
    const selectedClassPayload = actualLastSelectedClass
      ? [actualLastSelectedClass]
      : [activeUserClasses[0]];

    dispatch(setSelectedClass(selectedClassPayload));
  }, [activeUserClasses, dispatch, isLoading]);
};
